/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityTechAggResult } from './ControlEntityTechAggResult';
import {
    ControlEntityTechAggResultFromJSON,
    ControlEntityTechAggResultFromJSONTyped,
    ControlEntityTechAggResultToJSON,
} from './ControlEntityTechAggResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityTechAggResponse
 */
export interface ControlPaginatedEntityTechAggResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTechAggResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTechAggResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityTechAggResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityTechAggResult>}
     * @memberof ControlPaginatedEntityTechAggResponse
     */
    results?: Array<ControlEntityTechAggResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityTechAggResponse interface.
 */
export function instanceOfControlPaginatedEntityTechAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityTechAggResponseFromJSON(json: any): ControlPaginatedEntityTechAggResponse {
    return ControlPaginatedEntityTechAggResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityTechAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityTechAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityTechAggResultFromJSON)),
    };
}

export function ControlPaginatedEntityTechAggResponseToJSON(value?: ControlPaginatedEntityTechAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityTechAggResultToJSON)),
    };
}

